export default {"src":"/_next/static/media/membership-3.00fa85b6.svg","height":97,"width":242,"blurWidth":0,"blurHeight":0};